const footerNav = [
  {
    title: '观影导航',
    links: [
      { label: '精选推荐', href: '#cards' },
      { label: '热映榜单', href: '#ranking' },
      { label: '精彩预告', href: '#media' },
      { label: '专题聚焦', href: '#carousel' },
      { label: '片库索引', href: '#index' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '最新动态', href: '#updates' },
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
    ],
  },
  {
    title: '电影类型',
    links: [
      { label: '科幻电影', href: '#index' },
      { label: '动作电影', href: '#index' },
      { label: '喜剧电影', href: '#index' },
      { label: '悬疑电影', href: '#index' },
      { label: '动画电影', href: '#index' },
    ],
  },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-background-950 text-background-50 pt-14 md:pt-20 pb-8">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-12 md:mb-16">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-foreground-950"></i>
              </div>
              <span className="text-xl font-heading text-background-50">六六影院</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed mb-5">
              六六影院电影大全汇聚最新上映大片、经典高清电影，免费在线观看不缓冲，
              涵盖动作、科幻、喜剧全类型，一站式观影首选。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:bg-background-50/20 hover:text-background-50/90 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:bg-background-50/20 hover:text-background-50/90 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:bg-background-50/20 hover:text-background-50/90 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-lg"></i>
              </div>
            </div>
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 pt-8 mb-6">
          <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
          <p className="text-sm text-background-50/40">
            感谢以下伙伴对六六影院的关注与支持（排名不分先后）
          </p>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2020-2026 六六影院 版权所有 | 六六影院电影大全 - 最新高清电影免费在线观看
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}